import React, { useEffect, useRef } from 'react';
export function PricingCTA() {
  const sectionRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
        }
      });
    }, {
      threshold: 0.1
    });
    const reveals = sectionRef.current?.querySelectorAll('.reveal');
    reveals?.forEach(el => observer.observe(el));
    return () => observer.disconnect();
  }, []);
  return <section ref={sectionRef} id="comprar" className="py-24 px-4" style={{
    background: 'linear-gradient(160deg, #2C1810 0%, #3D2015 40%, #2C1810 100%)'
  }} data-id="element-161">
      {/* Decorative top glow */}
      <div className="absolute left-1/2 -translate-x-1/2 w-96 h-32 pointer-events-none opacity-30" style={{
      background: 'radial-gradient(ellipse, #D4A853 0%, transparent 70%)',
      filter: 'blur(20px)'
    }} data-id="element-162" />

      <div className="max-w-2xl mx-auto relative" data-id="element-163">
        {/* Urgency badge */}
        <div className="reveal text-center mb-8" data-id="element-164">
          <span className="inline-block font-lato font-black text-xs uppercase tracking-widest px-5 py-2 rounded-full" style={{
          background: 'rgba(196, 113, 74, 0.2)',
          color: 'var(--color-terracotta)',
          border: '1px solid rgba(196, 113, 74, 0.4)'
        }} data-id="element-165">
            🔥 Precio especial de lanzamiento
          </span>
        </div>

        {/* Main headline */}
        <h2 className="reveal reveal-delay-1 font-playfair text-4xl md:text-5xl lg:text-6xl font-bold text-center mb-6 leading-tight" style={{
        color: 'var(--color-cream)'
      }} data-id="element-166">
          Piel que te haga{' '}
          <span style={{
          background: 'linear-gradient(135deg, #D4A853, #E8C47A)',
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
          backgroundClip: 'text'
        }} data-id="element-167">
            sonreír
          </span>
          <br data-id="element-168" />a las 19:45
        </h2>

        {/* Price breakdown box */}
        <div className="reveal reveal-delay-2 rounded-3xl p-8 mb-8" style={{
        background: 'rgba(253, 248, 240, 0.05)',
        border: '1px solid rgba(212, 168, 83, 0.3)'
      }} data-id="element-169">
          <div className="space-y-4 mb-6" data-id="element-170">
            <div className="flex items-center justify-between" data-id="element-171">
              <span className="font-lato text-base" style={{
              color: 'rgba(253, 248, 240, 0.75)'
            }} data-id="element-172">
                🛒 Kit Mercadona (8 ingredientes)
              </span>
              <span className="font-lato font-bold" style={{
              color: 'var(--color-cream)'
            }} data-id="element-173">
                12€
              </span>
            </div>
            <div className="border-t" style={{
            borderColor: 'rgba(212, 168, 83, 0.15)'
          }} data-id="element-174" />
            <div className="flex items-center justify-between" data-id="element-175">
              <span className="font-lato text-base" style={{
              color: 'rgba(253, 248, 240, 0.75)'
            }} data-id="element-176">
                📄 Protocolo Exosome Express
              </span>
              <div className="flex items-center gap-2" data-id="element-177">
                <span className="font-lato text-sm line-through" style={{
                color: 'rgba(253, 248, 240, 0.35)'
              }} data-id="element-178">
                  €17
                </span>
                <span className="font-playfair text-xl font-black" style={{
                color: 'var(--color-gold)'
              }} data-id="element-179">
                  €6.39
                </span>
              </div>
            </div>
            <div className="border-t" style={{
            borderColor: 'rgba(212, 168, 83, 0.15)'
          }} data-id="element-180" />
            <div className="flex items-center justify-between" data-id="element-181">
              <span className="font-lato font-bold text-base" style={{
              color: 'var(--color-cream)'
            }} data-id="element-182">
                💰 Total inversión
              </span>
              <div className="flex items-center gap-2" data-id="element-183">
                <span className="font-lato text-sm line-through" style={{
                color: 'rgba(253, 248, 240, 0.35)'
              }} data-id="element-184">
                  €29
                </span>
                <span className="font-playfair text-2xl font-black" style={{
                color: 'var(--color-gold)'
              }} data-id="element-185">
                  €18.39
                </span>
              </div>
            </div>
          </div>

          {/* Features list */}
          <div className="space-y-2 pt-4 border-t" style={{
          borderColor: 'rgba(212, 168, 83, 0.15)'
        }} data-id="element-186">
            <div className="flex items-center gap-3" data-id="element-187">
              <span style={{
              color: 'var(--color-gold)'
            }} data-id="element-188">
                ✓
              </span>
              <span className="font-lato text-sm" style={{
              color: 'rgba(253, 248, 240, 0.75)'
            }} data-id="element-189">
                PDF 38 páginas + checklists + hojas de trabajo
              </span>
            </div>
            <div className="flex items-center gap-3" data-id="element-190">
              <span style={{
              color: 'var(--color-gold)'
            }} data-id="element-191">
                ✓
              </span>
              <span className="font-lato text-sm" style={{
              color: 'rgba(253, 248, 240, 0.75)'
            }} data-id="element-192">
                Protocolo AM/PM 5-7 minutos
              </span>
            </div>
            <div className="flex items-center gap-3" data-id="element-193">
              <span style={{
              color: 'var(--color-gold)'
            }} data-id="element-194">
                ✓
              </span>
              <span className="font-lato text-sm" style={{
              color: 'rgba(253, 248, 240, 0.75)'
            }} data-id="element-195">
                Bonus: Diagrama masaje drenaje + adaptación estacional
              </span>
            </div>
            <div className="flex items-center gap-3" data-id="element-196">
              <span style={{
              color: 'var(--color-gold)'
            }} data-id="element-197">
                ✓
              </span>
              <span className="font-lato text-sm" style={{
              color: 'rgba(253, 248, 240, 0.75)'
            }} data-id="element-198">
                Acceso lifetime · Sin suscripciones
              </span>
            </div>
          </div>
        </div>

        {/* Main CTA */}
        <div className="reveal reveal-delay-3 text-center mb-6" data-id="element-199">
          <a href="https://glylife.com/cart/52895245762903:1" target="_blank" rel="noopener noreferrer" className="btn-gold-pulse inline-block font-lato font-black text-xl px-10 py-5 rounded-full transition-all duration-300 hover:scale-105 hover:brightness-110 w-full md:w-auto" style={{
          background: 'linear-gradient(135deg, #D4A853 0%, #E8C47A 50%, #D4A853 100%)',
          color: 'var(--color-dark)',
          boxShadow: '0 8px 30px rgba(212, 168, 83, 0.5)',
          backgroundSize: '200% auto'
        }} data-id="element-200">
            Obtén Tu Protocolo Ahora — €6.39 Único
          </a>
          <p className="font-lato text-sm mt-4" style={{
          color: 'rgba(253, 248, 240, 0.55)'
        }} data-id="element-201">
            Sin suscripciones · Acceso lifetime · Descarga inmediata
          </p>
        </div>

        {/* Trust row */}
        <div className="reveal reveal-delay-4 flex flex-wrap justify-center gap-4" data-id="element-202">
          <span className="font-lato text-sm font-bold px-4 py-2 rounded-full" style={{
          background: 'rgba(253, 248, 240, 0.06)',
          color: 'rgba(253, 248, 240, 0.6)',
          border: '1px solid rgba(253, 248, 240, 0.1)'
        }} data-id="element-203">
            🔒 Pago seguro
          </span>
          <span className="font-lato text-sm font-bold px-4 py-2 rounded-full" style={{
          background: 'rgba(253, 248, 240, 0.06)',
          color: 'rgba(253, 248, 240, 0.6)',
          border: '1px solid rgba(253, 248, 240, 0.1)'
        }} data-id="element-204">
            ⚡ Descarga inmediata
          </span>
          <span className="font-lato text-sm font-bold px-4 py-2 rounded-full" style={{
          background: 'rgba(253, 248, 240, 0.06)',
          color: 'rgba(253, 248, 240, 0.6)',
          border: '1px solid rgba(253, 248, 240, 0.1)'
        }} data-id="element-205">
            ♾️ Sin suscripciones
          </span>
        </div>

        {/* Footer note */}
        <p className="reveal reveal-delay-5 text-center font-lato text-xs mt-8" style={{
        color: 'rgba(253, 248, 240, 0.3)'
      }} data-id="element-206">
          © 2024 Exosome Express · Producto digital · No es un sustituto de
          consejo médico profesional
        </p>
      </div>
    </section>;
}